import { BaseSpace } from 'app/components/common/BaseSpace'
import { PADDING } from 'parkway-web-common'
import styled from 'styled-components'
import RegisterActionForTeamContainer from './RegisterForTeamContainer'
import RegisterActionForMemberContainer from './RegisterForMemberContainer'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import { PermissionEnum } from 'app/common/enum'

const RegisterActionForMember = () => {
  const { verifyPermission } = useVerifyPermission()

  return (
    <RootWrapper>
      <BaseSpace>
        <RegisterActionForMemberContainer />
        {verifyPermission(PermissionEnum.DeclareTeam) ? (
          <RegisterActionForTeamContainer />
        ) : null}
      </BaseSpace>
    </RootWrapper>
  )
}

export default RegisterActionForMember

const RootWrapper = styled.div`
  padding: ${PADDING.md};
`
